<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-stats-trend-chart" v-loading="loading">
    <div ref="chart" class="metrics-chart" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import WyChartModule from '../../library/wy-chart-module.js';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail-metrics-chart',
  props: ['data'],

  data() {
    return {
      loading: false,
      wyChart: null,
      selectedDateRange: null,
    }
  },

  watch: {
    data(dataList) {
      if(dataList != null) {
        this.buildChart(dataList);
      }
    }
  },

  computed: {
    ...mapGetters(['dataModel']),
  },

  methods: {
    prepareDataSet(title, dateList, valueList, color) {
      let dateset = {
        name: title,
        type: "scatter",
        mode: valueList.length > 1 ? "lines" : "lines+markers",
        cliponaxis: false,
        marker: {size: 8},
        line: {
          color: color
        },
        x: dateList,
        y: valueList,
        hovertext: valueList,
        hovertemplate: this.wyChart.hoverTemplateNoDate("d"),
      };

      return dateset;
    },
    
    buildChart(dataList) {
      if(this.$refs.chart && dataList) {
        
        let botOnlyContainedDataset = this.prepareDataSet("VA contained", dataList.dateList, dataList.botOnlyContainedList, "#99ABBE");
        let botOnlyEscalatedDataset = this.prepareDataSet("Live agent requested but not connected", dataList.dateList, dataList.botOnlyEscalatedList, "#9799C6");
        let botToLCOnlyDataset = this.prepareDataSet("VA engaged with live agent connected", dataList.dateList, dataList.botToLCOnlyList, "#3C4090");
        let lCOnlyListDataset = this.prepareDataSet("Live Agent only", dataList.dateList, dataList.lCOnlyList, "#254869");
        let traces = [botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset, lCOnlyListDataset];

        let layout = {
          autosize: true,
          height: 290,          
          dragmode: false, //'pan'
          separators: '.',
          showlegend: true,
          plot_bgcolor: 'white',
          hoverlabel: {
            namelength: 50,
            font: {
              size: 11
            },
            bordercolor: '#FCFEFF'
          },
          legend: {
            orientation: 'h',
            x: 0.12,
            y: -0.2,
            bgcolor: 'rgba(0,0,0,0)',
            //itemwidth: 50
          },
          margin: { l: 70, r: 40, t: 20, b: 40 },
          xaxis:  {
            type: 'date',
            tickformat: '%b %d %Y',
            autorange: true,
            showgrid: false,
            zeroline: false,
            automargin: true,
            showline: true,
            linecolor: '#dedede',
            position: 0,
            tickcolor: "transparent"
          },
          yaxis: {
            type: 'linear',
            autorange: true,
            //rangemode: 'tozero',
            separatethousands: true,
            ticksuffix: ' ',
            showgrid: true,
            showline: true,
            zeroline: false,
            linecolor: '#dedede',
            layer: 'below traces',
            fixedrange: true,
          }
        }        

        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        // eslint-disable-next-line no-undef
        Plotly.newPlot(this.$refs.chart, traces, layout, config);

        /*this.$refs.chart.on('plotly_hover', (data) => {          
          try {
            let dataPoint = data.points[0];
            if(dataPoint && dataPoint.data && dataPoint.data.marker) {              
              let pn = dataPoint.pointNumber;
              // let sizes = dataPoint.data.marker.size;
              // sizes[pn] = 8;
              // let update = {'marker': {size: sizes}};
              let colors = dataPoint.data.marker.color;
              colors[pn] = "#214586";
              let update = {'marker': {color: colors}};
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch {
            // catch error
          }
        });

        // mouse out on point
        this.$refs.chart.on('plotly_unhover', (data) => {
          try {
            let dataPoint = data.points[0];
            if(dataPoint && dataPoint.data && dataPoint.data.marker) {
              let pn = dataPoint.pointNumber;
              // let sizes = dataPoint.data.marker.size;
              // sizes[pn] = 0;
              // let update = {'marker': {size: sizes}};
              let colors = dataPoint.data.marker.color;            
              colors[pn] = "transparent";
              let update = {'marker': {color: colors}};
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch {
            // catch error
          }
        });*/
      }
    },
  },

  created() {
    this.wyChart = new WyChartModule();
  }
});
</script>

<style lang="scss">
.wy-analytics-stats-trend-chart {
  min-height: 200px;
  // box-shadow: 5px 5px 6px #0000001A;
  border-radius: 10px;
  // border: 1px solid #eee;
  background-color: transparent;
  padding: 20px 0 2px 0;
  margin-bottom: 25px;

  .title {
    font-size: 21px;
    font-weight: 600;
    line-height: 0;
    margin-left: 25px;
    color: #0B284F;
    padding-bottom: 15px;
  }

  .metrics-chart {
    width: 100%;
    .svg-container .legend .legendlines path.js-line {
      d: path("M 12 0 h 10");
      stroke-width: 10px !important;
    }
  }
}
</style>